import TapToRemoveMarker from './TapToRemoveMarker';

export default TapToRemoveMarker;
